var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"show-page"},[_c('Listener',{attrs:{"disable_extension_selector":true,"data-test-id":"apps-show-page"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }